import React from 'react';
import { Dialog } from '../Dialog.tsx';
import { T, TList } from '../../T/T.tsx';
/** Dialog component for showing fyi or confirmation dialogs. */ export function SimpleDialog({ open, onClose, title, body, confirmLabel, onConfirm, showCancelBtn = false, onDismiss }) {
    const handleClose = ()=>{
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        onClose();
    };
    const handleConfirm = ()=>{
        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
        handleClose();
    };
    const onConfirmClick = onConfirm != undefined ? handleConfirm : handleClose;
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleClose,
        size: "sm"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(TList, {
        id: body
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, showCancelBtn ? /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: handleClose
    }) : null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onConfirmClick
    }, confirmLabel != undefined ? /*#__PURE__*/ React.createElement(T, {
        id: confirmLabel
    }) : undefined)));
}
